import { createContext } from 'react';

const OrganisationContext = createContext();

export default OrganisationContext;
